import React, { useEffect, useState, Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
import { LazyMount } from '../components/LazyMount';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  // Defer non-critical UI (popup) until browser is idle to keep TTI low
  const [mountIdle, setMountIdle] = useState(false);
  useEffect(() => {
    const w = window as any;
    if ('requestIdleCallback' in window) {
      const id = w.requestIdleCallback(() => setMountIdle(true), {
        timeout: 4000
      });
      return () => w.cancelIdleCallback?.(id);
    }
    const t = setTimeout(() => setMountIdle(true), 3000);
    return () => clearTimeout(t);
  }, []);
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-424">
      <div data-id="element-425">
        {/* Above-the-fold: render immediately, no Suspense / no lazy boundaries */}
        <HeroSection data-id="element-426" />

        {/* Just below the fold — TrustBar is tiny and visible quickly. Mount eagerly via Suspense. */}
        <Suspense fallback={<div style={{
        minHeight: 60
      }} data-id="element-428" />} data-id="element-427">
          <TrustBar data-id="element-429" />
        </Suspense>

        {/* Each section below mounts only when it nears the viewport. This defers chunk download + render. */}
        <LazyMount minHeight={500} data-id="element-430">
          <Suspense fallback={null} data-id="element-431">
            <ContrastSection data-id="element-432" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={500} data-id="element-433">
          <Suspense fallback={null} data-id="element-434">
            <ForWhomSection data-id="element-435" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={600} data-id="element-436">
          <Suspense fallback={null} data-id="element-437">
            <BenefitsSection data-id="element-438" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={600} data-id="element-439">
          <Suspense fallback={null} data-id="element-440">
            <ContentPreview data-id="element-441" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={500} data-id="element-442">
          <Suspense fallback={null} data-id="element-443">
            <BonusSection data-id="element-444" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={700} data-id="element-445">
          <Suspense fallback={null} data-id="element-446">
            <PricingSection data-id="element-447" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={400} data-id="element-448">
          <Suspense fallback={null} data-id="element-449">
            <GuaranteeSection data-id="element-450" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={600} data-id="element-451">
          <Suspense fallback={null} data-id="element-452">
            <TestimonialsSection data-id="element-453" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={500} data-id="element-454">
          <Suspense fallback={null} data-id="element-455">
            <ExpertSection data-id="element-456" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={500} data-id="element-457">
          <Suspense fallback={null} data-id="element-458">
            <FAQSection data-id="element-459" />
          </Suspense>
        </LazyMount>

        <LazyMount minHeight={300} data-id="element-460">
          <Suspense fallback={null} data-id="element-461">
            <Footer data-id="element-462" />
          </Suspense>
        </LazyMount>

        <StickyCTA data-id="element-463" />
        {mountIdle && <Suspense fallback={null} data-id="element-464">
            <SocialProofPopup data-id="element-465" />
          </Suspense>}
      </div>
    </main>;
}